import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { Column, FormInput } from 'Shared/components';
import { CoveredPartyPayloadType } from '@clearcover/core-app-types';
import styles from './styles.module.css';

export type DriverStudentInfoProps = {
  options: {
    allowGoodStudentDiscount: boolean;
    studentStatus: Record<string, string>;
  };
};

export const DriverStudentInfo: FC<DriverStudentInfoProps> = ({ options }) => {
  const { handleBlur, setFieldValue, values } = useFormikContext<
    CoveredPartyPayloadType
  >();
  if (!options?.allowGoodStudentDiscount) return <Column />;
  return (
    <Column className={styles.driverInfoCol}>
      <FormInput
        variant="selectAutocomplete"
        name="goodStudentStatus"
        data-testid="good-student-status"
        onChange={(value: string) =>
          setFieldValue('student.goodStudentStatus', value)
        }
        onBlur={handleBlur}
        value={values.student?.goodStudentStatus}
        label="Full time student with a B average or higher"
        options={options.studentStatus}
      />
    </Column>
  );
};
